import React from 'react';
import { UiInput } from '../ui-kit/UiInput';

/* eslint-disable react/prop-types */
export function UiInputAdapter({ input, meta, ...rest }) {
  return (
    <UiInput
      {...input}
      {...rest}
      errorMessage={meta.touched ? meta.error || meta.submitError || '' : ''}
    />
  );
}
